import {otpType} from '@/common/Enum/otpType.Enum';
import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    QueryList,
    Renderer2,
    ViewChild,
    ViewChildren
} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import {Router} from '@angular/router';
import {LoaderService} from '@services/loader.service';
import {SharedService} from '@services/shared.service';
import {VerifyOtpService} from '@services/verify-otp.service';
import {ToastrService} from 'ngx-toastr';
import {interval, Observable, Subscription} from 'rxjs';

@Component({
    selector: 'app-verify-otp-resetpassword',
    templateUrl: './verify-otp-resetpassword.component.html',
    styleUrl: './verify-otp-resetpassword.component.scss'
})
export class VerifyOTPResetpasswordComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    public varifyOTPForm: FormGroup;
    public otpControl: FormControl; // Declare FormControl for OTP
    public minutesDisplay: number = 0;
    public secondsDisplay: number = 0;
    public timerSubscription: Subscription;
    public otpType: otpType;
    public email: string;
    public isAuthLoading = false;
    public errorMessage: string;
    otpForm: FormArray;

    isLoading$: Observable<boolean>;
    otp: string;
    showOtpComponent = true;
    @ViewChild('ngOtpInput', {static: false}) ngOtpInput: any;
    @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

    constructor(
        private renderer: Renderer2,
        private sendOtp: VerifyOtpService,
        private sharedDataService: SharedService,
        private toastr: ToastrService,
        private router: Router,
        private loaderService: LoaderService,
        private fb: FormBuilder
    ) {
        this.isLoading$ = this.loaderService.isLoading$;
    }
    ngOnInit() {
        this.renderer.addClass(
            document.querySelector('app-root'),
            'varifyotp-page'
        );
        this.startTimer();
        this.otpControl = new FormControl('');
        this.varifyOTPForm = new FormGroup({
            otp: this.otpControl
        });
        this.otpForm = this.fb.array([
            this.fb.control('', [Validators.required]),
            this.fb.control('', [Validators.required]),
            this.fb.control('', [Validators.required]),
            this.fb.control('', [Validators.required])
        ]);
        this.email = this.sharedDataService.getForgotEmail();
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.otpInputs.first.nativeElement.focus();
        }, 0);
    }
    getOtpValue(): string {
        return this.otpForm.value.join('');
    }
    onOtpInput(event: Event, index: number) {
        const input = event.target as HTMLInputElement;
        const value = input.value;

        if (value.length === 1 && index < this.otpForm.length - 1) {
            const nextInput = input.parentElement?.querySelectorAll('input')[
                index + 1
            ] as HTMLInputElement;
            nextInput?.focus();
        }

        // update OTP value if needed
        this.otp = this.getOtpValue();
    }

    onOtpKeyDown(event: KeyboardEvent, index: number) {
        const input = event.target as HTMLInputElement;

        // Go to previous input if backspace is pressed and field is empty
        if (event.key === 'Backspace' && input.value === '' && index > 0) {
            const prevInput = input.parentElement?.querySelectorAll('input')[
                index - 1
            ] as HTMLInputElement;
            prevInput?.focus();
        }
    }
    onOtpPaste(e: ClipboardEvent) {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text');
        if (pasted.length !== 4) {
            return;
        }
        const digits = pasted.replace(/\D/g, '').slice(0, this.otpForm.length);

        digits.split('').forEach((digit, index) => {
            const control = this.otpForm.at(index);
            if (control) {
                control.setValue(digit);
            }
        });
        this.otpInputs.last.nativeElement.focus();
    }
    onOtpChange(otp) {
        this.otp = otp;
    }
    verifyOtp() {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        if (this.otpForm.valid) {
            this.email = this.sharedDataService.getForgotEmail();
            const otpValue = this.otp;
            this.sendOtp
                .verifyResetpasswordOTP(
                    this.email,
                    otpValue,
                    otpType.forgotPassword
                )
                .subscribe({
                    next: (data) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.success('Successfully Verify Account');
                            this.router.navigate(['/recover-password']);
                        }, 2000);
                    },
                    error: (error) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.error('Invalid or expired OTP');
                        }, 2000);
                    }
                });
        } else {
            this.toastr.error('Please enter OTP');
        }
    }
    resendOtp() {
        this.isAuthLoading = true;
        this.loaderService.showLoader();
        this.email = this.sharedDataService.getForgotEmail();
        console.log(this.email);
        this.sendOtp.reSendOtp(this.email, otpType.forgotPassword).subscribe({
            next: (data) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    this.toastr.success('OTP Send Successfully');
                }, 2000);
            },
            error: (error) => {
                setTimeout(() => {
                    this.isAuthLoading = false;
                    this.loaderService.hideLoader();
                    this.toastr.error('OTP Not Send!');
                }, 2000);
            }
        });
    }
    private startTimer() {
        var duration = 600; // Duration in seconds (10 minutes = 600 seconds)
        this.timerSubscription = interval(1000).subscribe(() => {
            if (duration > 0) {
                duration--;
                this.minutesDisplay = Math.floor(duration / 60);
                this.secondsDisplay = duration % 60;
            } else {
                // Handle OTP expiration (e.g., show message, disable form)
                this.timerSubscription.unsubscribe(); // Stop the timer
            }
        });
    }
    navigateBack() {
        window.history.back(); // Navigate to the previous route
    }
    ngOnDestroy() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
        this.renderer.removeClass(
            document.querySelector('app-root'),
            'varifyotp-page'
        );
    }
}
